var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 11.56V23C2 24.0609 2.42143 25.0783 3.17157 25.8284C3.92172 26.5786 4.93913 27 6 27H26C27.0609 27 28.0783 26.5786 28.8284 25.8284C29.5786 25.0783 30 24.0609 30 23V11.56L18.096 18.884C17.4657 19.2718 16.7401 19.4771 16 19.4771C15.2599 19.4771 14.5343 19.2718 13.904 18.884L2 11.56Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 9.21067V9C30 7.93913 29.5786 6.92172 28.8284 6.17157C28.0783 5.42143 27.0609 5 26 5H6C4.93913 5 3.92172 5.42143 3.17157 6.17157C2.42143 6.92172 2 7.93913 2 9V9.21067L14.952 17.1813C15.2672 17.3752 15.63 17.4779 16 17.4779C16.37 17.4779 16.7328 17.3752 17.048 17.1813L30 9.21067Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact-email.ac5a657bf25938888f30bde31cc233e7.svg";
export { ForwardRef as ReactComponent };